
// export default ContactPage;
import React from "react";
import { motion } from "framer-motion";
import {
  FaEnvelope,
  FaMapMarkerAlt,
  FaLinkedin,
  FaFacebook,
  FaInstagram,
  FaTiktok,
  FaTwitter,
  // تم استيراد أيقونة الواتساب
  FaWhatsapp,
} from "react-icons/fa";
import contactBg from "../assets/images/contact-bg.webp";
import "../App.css";
const ContactPage = () => {

  // 🟢 التعديل الأخير المقترح: استخدام رابط wa.me/send لزيادة فرصة فتح التطبيق المثبت
  const getWhatsappLink = (phoneNumber) => {
    // إزالة أي رموز غير الأرقام
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    // استخدام wa.me/send/?phone=الرقم_الدولي&text=
    // هذا التنسيق يزيد أحياناً من فرصة فتح التطبيق مباشرة بدلاً من الويب.
    return `https://wa.me/send/?phone=${cleanedNumber}&text=`;
  };

  // 1. تعريف أرقام الهواتف المشتركة
  const commonPhones = [
    { number: "966509565618", label: "السعودية" },
    { number: "201100012601", label: "مصر" },
  ];

  // 2. تعريف بيانات المقرات
  const locations = [
    {
      id: "egypt",
      title: "جمهورية مصـــــــر العــــــربية",
      address: " مدينة كفر الشيخ  -  محافظة كفر الشيخ",
      email: "1.unborders@gmail.com",
      phones: commonPhones,
    },
    {
      id: "ksa",
      title: "المملكـــة العـــربيــة الســعوديــة",
      address: " القصيم - المملكة العربية السعودية",
      email: "1.unborders@gmail.com",
      phones: commonPhones,
    },
  ];

  return (
    <section className="contact-page">
      {/* القسم الأول: الصورة والنص */}
      <div
        className="contact-header-image"
        style={{
          backgroundImage: `url(${contactBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="overlay">
          <motion.h1
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            اتصل بنا
          </motion.h1>
          <motion.p
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
          >
            نرحّب بتواصلكم واستفساراتكم
          </motion.p>
        </div>
      </div>

      {/* الجزء السفلي من القسم الأول */}
      <div className="contact-header-bottom">
        <motion.h3
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          تواصل معنا
        </motion.h3>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          لا تتردد في الاتصال بنا
        </motion.h2>
      </div>

      {/* القسم الثاني: مقرات الشركة */}
      <motion.div
        className="contact-offices-container"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
      >
        <h2 className="section-title">مقرات الشركة</h2>

        {/* شبكة البطاقات لعرض المقرات بشكل متجاور */}
        <div className="offices-grid">
          {locations.map((location, index) => (
            <motion.div
              key={location.id}
              className="office-card"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
            >
              <h3>
                {location.title}
              </h3>

              {/* العنوان */}
              <p className="contact-item">
                <FaMapMarkerAlt className="icon location-icon" />
                <span>{location.address}</span>
              </p>

              {/* الهواتف المشتركة (رابط واتساب) */}
              <h4 className="card-subtitle">تواصل عبر واتساب</h4>
              {location.phones.map((phone, pIndex) => (
                <a
                  key={pIndex}
                  // استخدام دالة getWhatsappLink المحدثة
                  href={getWhatsappLink(phone.number)}
                  className="contact-link"
                  aria-label={`رقم واتساب ${phone.label}`}
                  target="_blank" // يفضل فتح رابط الواتساب في نافذة جديدة
                  rel="noopener noreferrer"
                >
                  <p className="contact-item">
                    {/* استخدام أيقونة الواتساب */}
                    <FaWhatsapp className="icon whatsapp-icon" />
                    {/* حل مشكلة علامة + المقلوبة عن طريق تحديد الاتجاه (dir="ltr") */}
                    <span dir="ltr">+{phone.number}</span>
                  </p>
                </a>
              ))}

              {/* البريد الإلكتروني المشترك */}
              <h4 className="card-subtitle">أرسل لنا بريدًا إلكترونيًا</h4>
              <a
                href={`mailto:${location.email}`}
                className="contact-link"
                aria-label="إرسال بريد إلكتروني"
              >
                <p className="contact-item">
                  <FaEnvelope className="icon email-icon" />
                  <span dir="ltr">{location.email}</span>
                </p>
              </a>
            </motion.div>
          ))}
        </div>
      </motion.div>

      {/* القسم الثالث: تابعنا على */}
      <motion.div
        className="contact-social-section"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h2>
          لا تتردد في الاتصال بنا للحصول على مزيد من المعلومات عن شركتنا أو خدماتنا.
        </h2>
        <p>تابعنا على</p>
        <div className="social-icons">
          <a href="#" aria-label="LinkedIn">
            <FaLinkedin />
          </a>
          <a href="https://www.tiktok.com/@unborders1?_r=1&_t=ZS-91N70Fe6407" aria-label="TikTok"><FaTiktok /></a>
          <a href="https://www.facebook.com/1.UNBORDERS/" aria-label="Facebook">
            <FaFacebook />
          </a>
          <a href="https://www.instagram.com/un.borders/" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href="https://x.com/UNBorders1" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
        </div>
      </motion.div>
    </section>
  );
};

export default ContactPage;